import { render, staticRenderFns } from "./InsabiMedicamentos.vue?vue&type=template&id=3ca4a772&"
import script from "./InsabiMedicamentos.vue?vue&type=script&lang=js&"
export * from "./InsabiMedicamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports